import ChevronRight from "@untitled-ui/icons-react/build/esm/ChevronRight";
import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";
import {
  SafetyOutlined,
  EditOutlined,
  DislikeOutlined,
  SettingOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import cnt from "../../services/definedConstant";
import "../../assets/styles/Bond.css";
import MainLayout from "../../components/layouts/enhancement/MainLayout";
import TopContent from "../../components/layouts/enhancement/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../customer/customer.config";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { BOM } from "../../services/definedMethod";
import {
  CollateralFacility,
  handleCollateralActionButtons,
} from "../../components/facilities/CollateralFacility";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const DetailedCollateral = (props) => {
  const { userData } = props;
  const { state: selectedCollateral } = useLocation();
  const { session } = userData;
  const navigate = useNavigate();

  const [collateralDetails, setCollateralDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  useEffect(() => {
    if (selectedCollateral) {
      getCollateralById(
        selectedCollateral.clientId,
        selectedCollateral.collateralId,
      );
    }
  }, []);

  function getCollateralById(clientId, collateralId) {
    let body = {
      session,
    };

    const url = `${apiConfig.Clients}/${clientId}/collaterals/${collateralId}`;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage || err);
        setIsLoading(false);
      } else {
        const objList = res;

        setCollateralDetails(objList);
        setIsLoading(false);

        // setMenuProps({
        //   items: handleCollateralActionButtons(objList),
        //   items: [
        //     {
        //       label: "Approve",
        //       key: "1",
        //       icon: <SafetyOutlined />,
        //     },
        //     {
        //       label: "Pledge",
        //       key: "2",
        //       icon: <CheckCircleOutlined />,
        //     },
        //     {
        //       label: "Release",
        //       key: "3",
        //       icon: <SettingOutlined />,
        //     },
        //     {
        //       label: "Liquidate",
        //       key: "4",
        //       icon: <CloseCircleOutlined />,
        //     },
        //     {
        //       label: "Apply Haircut",
        //       key: "5",
        //       icon: <DislikeOutlined />,
        //     },
        //   ],
        // });
        setMenuProps({
          items: handleCollateralActionButtons(objList),
          onClick: (e) => {
            console.log(e);

            const item = handleCollateralActionButtons(objList).find(
              (element) => element.key === e.key,
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                // case "approve":
                //   return activateBond();
                // case "disable":
                //   return disableBond();
                // case "close":
                //   return closeBond();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...selectedCollateral,
                      actionLabel: item.label,
                      collateral: objList,
                    },
                  });
              }
            }
          },
        });
      }
    });
  }

  const transformedData = [
    {
      section: "Collateral Overview",
      items: [
        {
          name: "Collateral Description",
          value: collateralDetails?.description ?? "-",
        },
        {
          name: "Issuer Code (Securities)",
          value: collateralDetails?.issuerCode ?? "-",
        },
        {
          name: "Ownership Verified",
          value: collateralDetails?.ownershipVerified ? "Yes" : "No",
          isTag: true,
        },
        {
          name: "Registration Date",
          value: formatFullDate(collateralDetails?.registrationDate),
        },
      ],
    },
    {
      section: "Ownership Details",
      items: [
        {
          name: "Customer Name",
          value: collateralDetails?.client?.fullname ?? "-",
        },
        {
          name: "Customer Type",
          value: collateralDetails?.client?.clientType?.name ?? "-",
        },
        {
          name: "Customer Phone Number",
          value: collateralDetails?.client?.mobileNo ?? "-",
        },
        {
          name: "Customer ID",
          value: collateralDetails?.client?.id ?? "-",
        },
        {
          name: "Ownership Type",
          value: collateralDetails?.ownershipType ?? "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Collateral Classification",
      items: [
        {
          name: "Collateral Type",
          value: collateralDetails?.collateralType ?? "-",
          isTag: true,
        },
        {
          name: "Exposure Type",
          value: collateralDetails?.exposureType ?? "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Collateral Valuation",
      items: [
        {
          name: "Currency",
          value: collateralDetails?.currencyData?.displayLabel ?? "-",
          isTag: true,
        },
        {
          name: "Collateral Nominal Value",
          value: collateralDetails?.nominalValue
            ? `NGN ${collateralDetails.nominalValue.toLocaleString()}`
            : "-",
        },
        {
          name: "Valuation Methods",
          value: collateralDetails?.valuationMethods ?? "-",
          isTag: true,
        },
        {
          name: "Periodic Revaluation",
          value: collateralDetails?.periodicRevaluation ? "Yes" : "No",
          isTag: true,
        },
        {
          name: "Historical Valuation Tracking",
          value: collateralDetails?.historicalTracking ? "Yes" : "No",
          isTag: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (transformedData[section]?.items?.length || 0) - 1;

    const getDisplayValue = (val) => {
      if (val == null || val === "") return "-";
      if (typeof val === "object")
        return val.text || val.value || JSON.stringify(val);
      return val.toString();
    };

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return item.group.map((fieldGroup, groupIndex) => (
        <div
          key={`inline-group-${fieldGroup.name}-${index}-${groupIndex}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          <div
            style={{
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#f9f9f9",
              fontWeight: "500",
              borderRight: "1px solid #f0f0f0",
            }}
          >
            {fieldGroup.name}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              padding: "16px 24px",
              width: "50%",
              backgroundColor: "#fff",
            }}
          >
            {fieldGroup.fields.map((subField) => (
              <div
                key={subField.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                {subField.isTag ? (
                  renderTag(getDisplayValue(subField.value))
                ) : (
                  <span>{getDisplayValue(subField.value)}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ));
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(getDisplayValue(item.value))
          ) : (
            <Text style={{ fontWeight: 600 }}>
              {getDisplayValue(item.value)}
            </Text>
          )}
        </div>
      </div>
    );
  };

  function activateCollateral() {
    BOM.AlertMsg(cnt.SUCCESS, "Collateral Activated successfully");
    setCollateralDetails({ ...collateralDetails, status: { text: "Active" } });
  }

  function rejectCollateral() {
    BOM.AlertMsg(cnt.SUCCESS, "Collateral Rejected");
    setCollateralDetails({
      ...collateralDetails,
      status: { text: "Rejected" },
    });
  }

  return (
    <MainLayout pageItems={staticConfig.detailCollateralBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.collateral}
        createPageTitle={labelConfig.detailCollateral}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            <CollateralFacility
              status={collateralDetails?.status?.value}
              name={collateralDetails?.collateralName}
              id={collateralDetails?.collateralCode}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData.map((section, index) => (
                <Col>
                  <Collapse
                    className="custom-collapse"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section.items.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index),
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedCollateral);
